import { useWealthSavingsSectionContent } from './useWealthSavingsSectionContent';
import { parseWealthSavingsProductsContent } from '../utils/wealthSavingsContent';

export const useWealthSavingsProductsContent = () =>
  useWealthSavingsSectionContent(parseWealthSavingsProductsContent);
